import { useTheme } from '@ihs-widget/stores/useTheme';
import { useEffect, useState } from 'react';
import Spinner from '@ihs-widget/components/common/Spinner';
import CustomScrollBar from '@ihs-widget/components/common/CustomScrollBar';
import { T, } from "@ihs-widget/utils/enums";
import RefreshIconAndText from '@ihs-widget/components/common/RefreshIconAndText';
import { useLoadingWithRefresh } from '@ihs-widget/utils/hooks/useLoadingWithRefresh';
import ScoreBoardScoreAndTimeDynamic from '@ihs-widget/components/StatsConsole/Widgets/common/StatsScoreboardTeam/ScoreBoards/ScoreBoardScoreAndTimeDynamic';
import ScoreBoardFormationDynamic from '@ihs-widget/components/StatsConsole/Widgets/common/StatsScoreboardTeam/ScoreBoards/ScoreBoardFormationDynamic';

interface IWidgetWrapperProps {
    statsData?: any;
    statsTabData?: any;
    children: React.ReactNode;
    eventId: string | null;
    overviewData?: any;
    overviewDataSorted?: any;
    isMVP?: boolean;
    matchTime?: any;
    childWidgetName: typeof T.TAB_STATS | typeof T.TAB_OVERVIEW | typeof T.TAB_PLAYERS | typeof T.TAB_LINEUP | typeof T.TAB_H2H;
    homeFormation?: string | null;
    awayFormation?: string | null;
    homeTeam?: string | null;
    awayTeam?: string | null;
    playersTabData?: any;
    lineupData?: any;
    isStatsWidgetPending?: boolean;
    isOverviewWidgetPending?: boolean;
    isPlayersWidgetPending?: boolean;
    isLineupWidgetPending?: boolean;
}

const WidgetWrapper = ({
    children,
    eventId,
    statsData,
    statsTabData,
    overviewData,
    overviewDataSorted,
    isMVP = true,
    matchTime,
    childWidgetName,
    homeFormation,
    awayFormation,
    homeTeam,
    awayTeam,
    playersTabData,
    lineupData,
    isStatsWidgetPending = true,
    isOverviewWidgetPending = true,
    isPlayersWidgetPending = true,
    isLineupWidgetPending = true,
}: IWidgetWrapperProps) => {
    const { theme } = useTheme();
    const [forceRefresh, setForceRefresh] = useState<number>(0)

    const { showRefreshIcon: showRefreshIconStats } = useLoadingWithRefresh([
        { data: statsTabData?.data, error: statsTabData?.error },
        { data: statsData?.data, error: statsData?.error }
    ]);

    const { showRefreshIcon: showRefreshIconOverview } = useLoadingWithRefresh({
        data: overviewData?.data, error: overviewData?.error
    });

    const { showRefreshIcon: showRefreshIconLineups } = useLoadingWithRefresh([
        { data: lineupData?.data, error: lineupData?.error },
    ]);

    const { showRefreshIcon: showRefreshIconPlayers } = useLoadingWithRefresh([
        { data: playersTabData?.data, error: playersTabData?.error },
    ]);

    const generateViewId = () => {
        if (childWidgetName === T.TAB_STATS) {
            return 'stats';
        } else if (childWidgetName === T.TAB_OVERVIEW) {
            return 'overview';
        } else if (childWidgetName === T.TAB_PLAYERS) {
            return 'players';
        } else if (childWidgetName === T.TAB_LINEUP) {
            return 'lineups';
        } else {
            return 'stats';
        }
    }

    useEffect(() => {
        setForceRefresh(new Date().getTime())
    }, [overviewDataSorted])

    const isPlayersOrLineups = childWidgetName === T.TAB_PLAYERS || childWidgetName === T.TAB_LINEUP;
    const isStatsOrOverview = childWidgetName === T.TAB_STATS || childWidgetName === T.TAB_OVERVIEW;
    const showScoreAndTime = isStatsOrOverview;
    const showFormation = isPlayersOrLineups;

    if (childWidgetName === T.TAB_STATS && isStatsWidgetPending) {
        return showRefreshIconStats ? (
            <RefreshIconAndText addClass="pt-[100px]" />
        ) : <Spinner />;
    }

    if (childWidgetName === T.TAB_OVERVIEW && isOverviewWidgetPending) {
        return showRefreshIconOverview ? (
            <RefreshIconAndText addClass="pt-[100px]" />
        ) : (
            <Spinner />
        );
    }

    if (childWidgetName === T.TAB_PLAYERS && isPlayersWidgetPending) {
        return showRefreshIconPlayers ? (
            <RefreshIconAndText addClass="pt-[100px]" />
        ) : <Spinner />;
    }

    if (childWidgetName === T.TAB_LINEUP && isLineupWidgetPending) {
        return showRefreshIconLineups ? (
            <RefreshIconAndText addClass="pt-[100px]" />
        ) : <Spinner />;
    }




    return (
        <div className={`${theme === T.DARK ? 'tinny-scrollbar-dark' : 'tinny-scrollbar'} 
                        flex flex-col w-full overflow-y-hidden overflow-x-hidden`}
        >
            <CustomScrollBar viewId={childWidgetName} paddingTopOff={true} forceRefresh={forceRefresh}>
                <div className={showScoreAndTime ? '' : 'hidden'}>
                    <ScoreBoardScoreAndTimeDynamic eventId={eventId} overviewData={overviewData} isMVP={isMVP} matchTime={matchTime} homeTeamName={homeTeam} awayTeamName={awayTeam} />
                </div>
                <div className={showFormation ? '' : 'hidden'}>
                    <ScoreBoardFormationDynamic homeTeam={homeTeam || ''} awayTeam={awayTeam || ''} homeFormation={homeFormation || ''} awayFormation={awayFormation || ''} />
                </div>
                {children}
            </CustomScrollBar>
        </div>
    )
}

export default WidgetWrapper;
